// Should stay in sync with recentUpdatesNotificationUnionGraphqlTypes.mjs

export const RECENT_UPDATES_NOTIFICATION_UNION_GRAPHQL_TYPES = {
  APPRAISAL_NOTIFICATION_TYPENAME: 'AppraisalNotification',
  CHECKPOINT_NOTIFICATION_TYPENAME: 'CheckpointNotification',
  EVENT_CHANGE_DATE_REQUEST_EDIT_EVENT_REVIEW_NOTIFICATION_TYPENAME:
    'EventChangeDateRequestEditEventReviewNotification',
  EVENT_CHANGE_DATE_REQUEST_REVIEW_PAGE_NOTIFICATION_TYPENAME:
    'EventChangeDateRequestReviewPageNotification',
  OBSERVATION_REPORT_REVIEW_PAGE_NOTIFICATION_TYPENAME: 'ObservationReportReviewPageNotification'
};
